import styled from 'styled-components';

export const IconList = styled.ul`
  display: grid;
  grid-template: columns;
  grid-gap: 3.5rem;
  margin-bottom: ${(props) => (props.mb ? `${props.mb}px` : 0)};
  margin-top: ${(props) => (props.mt ? `${props.mt}px` : 0)};
`;
